import { Callout } from "@octopusdeploy/design-system-components";
import type { PrimaryPageAction } from "@octopusdeploy/design-system-components";
import type { ServerStatusResource, ActivityLogElement } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { noOp } from "@octopusdeploy/utilities";
import { reverse } from "lodash";
import { repository } from "~/clientInstance";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import { PageContent } from "~/components/PageContent/PageContent";
import { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
import { Section } from "~/components/Section/Section";
import TaskLogLines from "~/components/TaskLogLines/TaskLogLines";
import HALogWarning from "./HALogWarning";
interface DetailedServerLogsState extends DataBaseComponentState {
    status?: ServerStatusResource;
    logs?: ActivityLogElement[];
    isHA: boolean;
}
export class DetailedServerLogsPage extends DataBaseComponent<{}, DetailedServerLogsState> {
    constructor(props: {}) {
        super(props);
        this.state = { isHA: false };
    }
    async componentDidMount() {
        const nodes = repository.OctopusServerNodes.list();
        await this.doBusyTask(async () => {
            await this.refresh();
            this.setState({ isHA: (await nodes).Items.length > 1 });
        });
    }
    refresh = async () => {
        const status = await repository.ServerStatus.getServerStatus();
        this.setState({
            status,
            logs: reverse(await repository.ServerStatus.getLogs(status)),
        });
    };
    render() {
        const refreshPageAction: PrimaryPageAction | undefined = this.state.logs
            ? {
                type: "button",
                label: "Refresh",
                busyLabel: "Refreshing...",
                disabled: this.state.busy,
                onClick: this.refresh,
                hasPermissions: isAllowed({ permission: Permission.AdministerSystem }),
            }
            : undefined;
        return (<PageContent header={{ title: "Detailed Server Logs", breadcrumbs: [{ label: "Diagnostics", pageUrl: links.diagnosticsPage.generateUrl() }], primaryAction: refreshPageAction }} busy={this.state.busy} errors={this.errors}>
                {this.state.logs && (<div>
                        <Section>The entries below are the most recent warning and error-level events recorded on this Octopus Server node in this session.</Section>
                        <HALogWarning isHA={this.state.isHA}/>
                        {this.state.logs.length === 0 && (<Section>
                                <Callout type={"information"} title={"No events found"}>
                                    No warning or error-level events have been collected in this session.
                                </Callout>
                            </Section>)}
                        <Section>
                            <TaskLogLines lines={this.state.logs} showTimestamps={true} onFetchRange={noOp} isFetchDisabled={true}/>
                        </Section>
                    </div>)}
            </PageContent>);
    }
    static displayName = "DetailedServerLogsPage";
}
